<app-layout>
  <app-voltar />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (change)="this.consultarValor()">
      <!-- Cadastro / Editar (layout alinhado à tela de entrada) -->
      <ng-container *ngIf="!title.includes('Visualizar')">
        <h3 class="section-title">Dados do agendamento</h3>
        <div class="formList">
          <app-input
            type="datetime-local"
            label="Data do agendamento"
            name="DT_AGND"
            width="100%"
            formControlName="DT_AGND"
            [requiredInput]="true"
          ></app-input>

          <div class="turno-wrapper">
            <app-input
              type="text"
              label="Turno"
              name="turno"
              formControlName="TURNO"
              [requiredInput]="true"
              [disabled]="true"
              placeholder="Selecione a data para definir o turno"
            />
          </div>

          <app-input
            type="select"
            label="Janela"
            name="FK_JNLA"
            formControlName="FK_JNLA"
            placeholder="Selecione"
            [requiredInput]="true"
            [disabled]="disabledAgendamento"
            [selectData]="janelaOptions"
          ></app-input>

          <app-input
            type="select"
            label="Serviço"
            name="FK_SRVC"
            formControlName="FK_SRVC"
            placeholder="Selecione"
            [requiredInput]="true"
            [disabled]="disabledAgendamento"
            [selectData]="servicoOptions"
            (ngModelChange)="escolherServico($event)"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Caminhão</h3>
        <div class="formList">
          <app-input
            type="select"
            label="Placa Cavalo"
            name="FK_CAVA"
            formControlName="FK_CAVA"
            placeholder="Selecione"
            [requiredInput]="true"
            [disabled]="disabledAgendamento"
            [selectData]="cavaloOptions"
            (ngModelChange)="escolherPlacaCavalo($event)"
          ></app-input>
          <app-input
            type="select"
            label="Carreta 1"
            name="FK_CRRT_1"
            formControlName="FK_CRRT_1"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="carretaOptions1"
            (ngModelChange)="escolherPlacaCarreta($event, 1)"
          ></app-input>
          <app-input
            type="select"
            label="Carreta 2"
            name="FK_CRRT_2"
            formControlName="FK_CRRT_2"
            placeholder="Selecione"
            [selectData]="carretaOptions2"
            (ngModelChange)="escolherPlacaCarreta($event, 2)"
          ></app-input>
          <app-input
            type="select"
            label="Carreta 3"
            name="FK_CRRT_3"
            formControlName="FK_CRRT_3"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="carretaOptions3"
            (ngModelChange)="escolherPlacaCarreta($event, 3)"
          ></app-input>
        </div>

        <h3 class="section-title">Dados da Nota Fiscal</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nota Fiscal"
            name="TX_NOTA_FISCAL"
            formControlName="TX_NOTA_FISCAL"
            placeholder="Nº da nota fiscal"
            [disabled]="disabledAgendamento"
          ></app-input>
          <app-input
            type="number"
            label="Volume"
            name="NU_VOLUME"
            formControlName="NU_VOLUME"
            placeholder="Digite o volume"
            [disabled]="disabledAgendamento"
          ></app-input>
          <app-input
            type="number"
            label="Peso (Ton)"
            name="NU_PESO_TON"
            formControlName="NU_PESO_TON"
            placeholder="Digite o peso"
            [disabled]="disabledAgendamento"
          ></app-input>
          <app-input
            type="select"
            label="Produto"
            name="FK_CRGA"
            formControlName="FK_CRGA"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="cargaOptions"
          ></app-input>
          <app-input
            type="select"
            label="Destinatário"
            name="FK_DTNR"
            formControlName="FK_DTNR"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="destinatarioOptions"
          ></app-input>
        </div>

        <h3 class="section-title">Dados da Transportadora</h3>
        <div class="formList">
          <app-input
            type="select"
            label="Nome"
            name="FK_TPTD"
            formControlName="FK_TPTD"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="transportadoraOptions"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Cliente</h3>
        <div class="formList">
          <app-input
            type="select"
            label="Nome"
            name="FK_CLNT"
            formControlName="FK_CLNT"
            placeholder="Selecione"
            [disabled]="disabledAgendamento"
            [selectData]="clienteOptions"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Motorista</h3>
        <div class="formList">
          <app-input
            type="select"
            label="Nome do Motorista"
            name="FK_MTRT_EPSA"
            formControlName="FK_MTRT_EPSA"
            placeholder="Selecione"
            [requiredInput]="true"
            [disabled]="disabledAgendamento"
            [selectData]="motoristaOptions"
            (ngModelChange)="escolherMotorista($event)"
          ></app-input>
        </div>

        <div class="formList">
          <app-input
            type="textarea"
            class="full-width"
            label="Observação"
            name="TX_OBSV_AGND"
            formControlName="TX_OBSV_AGND"
            placeholder="Digite aqui"
            width="100%"
            [requiredInput]="false"
            [disabled]="disabledAgendamento"
          ></app-input>
        </div>
        <p *ngIf="visible">
          As opções de serviço(s) selecionada(s), resultam no custo de R$
          {{ this.valorServico }}.
        </p>
        <app-botao
          type="cadastro"
          text="Concluir agendamento"
          class="botao-cadastro"
          (click)="postarDados()"
          [disabled]="!form.valid"
        ></app-botao>
      </ng-container>

      <!-- Visualizar: mesma disposição da tela de entrada -->
      <ng-container *ngIf="title.includes('Visualizar')">
        <h3 class="section-title">Dados do agendamento</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Data do Agendamento"
            name="DT_AGND"
            width="100%"
            formControlName="DT_AGND"
            [disabled]="true"
          ></app-input>

          <app-input
            type="text"
            label="Turno"
            name="TURNO"
            formControlName="TURNO"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Janela"
            name="NM_JNLA"
            formControlName="NM_JNLA"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Serviço"
            name="NM_SRVC"
            formControlName="NM_SRVC"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados da Nota Fiscal</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nota Fiscal"
            name="TX_NOTA_FISCAL"
            formControlName="TX_NOTA_FISCAL"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Volume"
            name="NU_VOLUME"
            formControlName="NU_VOLUME"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Peso (Ton)"
            name="NU_PESO_TON"
            formControlName="NU_PESO_TON"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Produto"
            name="NM_CRGA"
            formControlName="NM_CRGA"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Destinatário"
            name="NM_DTNR"
            formControlName="NM_DTNR"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados da Transportadora</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_TPTD"
            formControlName="NM_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="CNPJ"
            name="TX_CNPJ_TPTD"
            formControlName="TX_CNPJ_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="TX_CNTT_TPTD"
            formControlName="TX_CNTT_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Cliente</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_CLNT"
            formControlName="NM_CLNT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="CNPJ"
            name="TX_CNPJ_CLNT"
            formControlName="TX_CNPJ_CLNT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Caminhão</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Placa Cavalo"
            name="TX_PLCA_CAVA"
            formControlName="TX_PLCA_CAVA"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Placas das carretas"
            name="TX_PLCA_CRRT_UNIFICADA"
            formControlName="TX_PLCA_CRRT_UNIFICADA"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Tipo da Carreta"
            name="NM_TIPO_CRRT"
            formControlName="NM_TIPO_CRRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Motorista</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome do Motorista"
            name="NM_MTRT"
            formControlName="NM_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="CPF"
            name="TX_CPF"
            formControlName="TX_CPF"
            mask="000.000.000-00"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="CNH"
            name="TX_CNH"
            formControlName="TX_CNH"
            [disabled]="true"
            placeholder="---"
          ></app-input>

          <app-input
            type="text"
            label="Contato"
            name="NU_TELE"
            formControlName="NU_TELE"
            mask="(00) 00000-0000"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <div class="formList">
          <app-input
            type="textarea"
            class="full-width"
            label="Observação"
            name="TX_OBSV_AGND"
            formControlName="TX_OBSV_AGND"
            placeholder="Digite aqui"
            width="100%"
            [disabled]="true"
          ></app-input>
        </div>

        <app-input
          *ngIf="statusAgendamentoValue === 3"
          type="textarea"
          label="Motivo do cancelamento"
          name="TX_MOTV_CNCL_AGND"
          [ngModel]="motivoCancelamento || '---'"
          [ngModelOptions]="{ standalone: true }"
          width="100%"
          [disabled]="true"
        ></app-input>

        <app-botao
          *ngIf="statusAgendamentoValue === 1 || statusAgendamentoValue === 6"
          type="cadastro"
          text="Registrar entrada no gate"
          class="botao-cadastro"
          (click)="registrarEntradaGate()"
        ></app-botao>
      </ng-container>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
